// extracted by mini-css-extract-plugin
export var description = "shortHero-module--description--N-8In";
export var downCaret = "shortHero-module--downCaret--Dq+nh";
export var h1 = "shortHero-module--h1--9BaIr";
export var hero = "shortHero-module--hero--LM2FE";
export var heroDetails = "shortHero-module--heroDetails---FggO";
export var heroHeadline = "shortHero-module--heroHeadline--metnK";
export var heroImage = "shortHero-module--heroImage--R3-93";
export var heroSubtitle = "shortHero-module--heroSubtitle--47Wfh";
export var heroTitle = "shortHero-module--heroTitle--tR+2i";
export var infoIcon = "shortHero-module--infoIcon--1cJh9";
export var mobileDescription = "shortHero-module--mobileDescription--SggpS";
export var mobileDescriptionBox = "shortHero-module--mobileDescriptionBox--MVb1M";
export var subtitle = "shortHero-module--subtitle--Rx+b9";